export const defaultChartFieldsConfig = {
    JobPosting: [
        'status',
        'isApproved',
        'title',
        'departmentId',
        'location',
        'hiringManagerEmail',
        'recruiterEmail',
        'employmentType',
        'newOrReplacement',
        'createdAt',
        'minWorkExperience',
        'maxWorkExperience',
        'minSalaryExpectation',
        'maxSalaryExpectation',
        'country',
        'currency',
        'status',
    ],
    JobApplication: [
        'firstName',
        'lastName',
        'currentDesignation',
        'currentCompany',
        'latestDegree',
        'latestInstitution',
        'yearsOfExperience',
        'location',
        'noticePeriodInDays',
        'status',
        'createdAt',
        'appliedBy',
        'statusChangeDate',
    ],
    Candidate: [
        'location',
        'yearsOfExperience',
        'firstName',
        'lastName',
        'email',
        'phone',
        'currentCompany',
        'currentDesignation',
        'applicationType',
        'profileVerified',
    ],
    InterviewRound: ['roundType', 'status'],
    PanellistFeedback: ['name', 'email', 'comments', 'recommendation', 'status'],
}
